<template>
  <div class="row py-5" id="collaborators">
    <div class="col-12">
      <div class="container-xxl">
        <div class="">

          <div class="collaborators-container" >
            <div class="col-11 mx-auto mb-5">
              <h2 class="title">O que<strong> nos inspira</strong></h2>
            </div>

            <div class="swiper-container swiper mySwiper" ref="mySwiper2">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, i) in collaboratorsArea" :key="i">
                  <div class="collaborators">
                    <div class="left">
                      <img :src="require(`@/assets/images/${item.image}`)" alt="colaborador">
                    </div>
                  <div class="right">
                    <div class="testimony" v-html="item.content"></div>
                    <div class="name" v-html="item.name"></div>
                    <div class="funcao" v-html="item.func"></div>
                  </div>
                  </div>
                </div>
              </div>
              <div
                style="color: #00CFD9"
                class="swiper-button-prev swiper-button-prev2"
                ref="swiper-button-prev2"
              ></div>
              <div
                style="color: #00CFD9"
                class="swiper-button-next swiper-button-next2"
                ref="swiper-button-next2"
              ></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from "swiper";
  import "swiper/swiper-bundle.css";
  import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
  SwiperCore.use([Navigation, Pagination, Autoplay]);

  export default {
    name: 'Collaborators',

    data(){
      return {
      }
    },

    computed: {
      collaboratorsArea(){
        return this.$store.state.collaboratorsArea;
      },
    },

    methods: {
    },

    mounted(){
      setTimeout(() => {
        var swiper3 = new Swiper(this.$refs["mySwiper2"], {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: this.$refs["swiper-button-next2"],
            prevEl: this.$refs["swiper-button-prev2"],
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          },
        });
      }, 150);
    }
  }
</script>

<style lang="scss" scoped>
  #collaborators{
    padding: 0 40px;

    @include media-breakpoint-down(md) {
      padding: 0
    }
  }

  .collaborators-container{
    width: 100%;
    color: #0A1D6F;
    padding: 0 0;

    .title{
      font-size: 36px;
      text-align: center;
      font-weight: 400;
      strong{
        color: #00CFD9;
      }
    }

    .collaborators{
      display: flex;
      justify-content: space-between;
      width: calc(70% - 130px);
      margin: auto;
      align-items: center;

      .swiper-container {
        position: unset;
        min-height: 40rem;
        @include media-breakpoint-down(md) {
          min-height: fit-content;
        }
      }

      .left{
        img{
          max-width: 240px;
          height: 350px;
          object-fit: cover;
          object-position: 58% center;
          border-radius: 50%;
        }
      }

      .right{
        width: auto;
        text-align: justify;
        margin-top: 10px;
        padding: 5px 5px 5px 20px;
        margin-left: 20px;

        .name{
          color: #0A1D6F;
          margin-top: 10px;
        }

        .funcao{
          color: #00CFD9;
          margin-top: -10px;
        }
      }

      @include media-breakpoint-down(sm){
        width: 100%;
        flex-direction: column;
        justify-content: center;
        height: auto;
        .right{
          padding: 10px;
          //height: 100%;
        }
        .left{
          text-align: center;
          img{
            max-width: 170px;
          }
        }
      }
    }

    .swiper-button-prev, .swiper-button-next {
      @media screen and (max-width: 1100px) {
        top: 38%;
      }
    }
  }
</style>